"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TextAction = exports.SelectAction = exports.InputAction = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _classnames = _interopRequireDefault(require("classnames"));
var _hover = require("../../hooks/hover");
var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));
var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var _default = exports["default"] = function _default(_ref) {
  var label = _ref.label,
    onRemove = _ref.onRemove,
    renderAction = _ref.renderAction;
  var _useHover = (0, _hover.useHover)(),
    hovered = _useHover.hovered,
    targetProps = _useHover.targetProps;
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, targetProps, {
    className: "flex items-center min-w-0 py-4 pl-6 rounded-lg shadow-lg bg-card h-full"
  }), /*#__PURE__*/_react["default"].createElement("label", {
    className: "flex-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs font-semibold uppercase text-gray-light"
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-lg font-semibold text-dark"
  }, renderAction())), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('px-4 text-gray-light opacity-0', {
      'opacity-100': hovered
    })
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    color: "inherit",
    size: "small",
    onClick: onRemove
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null))));
};
var TextAction = exports.TextAction = function TextAction(_ref2) {
  var name = _ref2.name,
    value = _ref2.value,
    label = _ref2.label;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, label, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name,
    value: value,
    className: "hidden"
  }));
};
var InputAction = exports.InputAction = function InputAction(_ref3) {
  var name = _ref3.name,
    value = _ref3.value,
    label = _ref3.label;
  var _useState = (0, _react.useState)(!!value),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    disabled = _useState2[0],
    setDisabled = _useState2[1];
  return disabled ? /*#__PURE__*/_react["default"].createElement(TextAction, {
    name: name,
    value: value,
    label: value
  }) : /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name,
    render: function render(_ref4) {
      var field = _ref4.field;
      return /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, field, {
        autoFocus: true,
        disabled: disabled,
        autoComplete: "off",
        onBlur: function onBlur() {
          return !!(field.value || '').trim() ? setTimeout(function () {
            return setDisabled(true);
          }, 100) : null;
        },
        onKeyPress: function onKeyPress(e) {
          if (e.charCode === 13 && !!(field.value || '').trim()) setDisabled(true);
        },
        className: (0, _classnames["default"])('font-semibold rounded-none border-b-2 border-primary', 'bg-transparent opacity-50 focus:opacity-100 hover:opacity-100')
      }));
    }
  });
};
var SelectAction = exports.SelectAction = function SelectAction(_ref5) {
  var name = _ref5.name,
    value = _ref5.value,
    label = _ref5.label,
    placeholder = _ref5.placeholder,
    renderOptions = _ref5.renderOptions;
  var _useState3 = (0, _react.useState)(!!value),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    disabled = _useState4[0],
    setDisabled = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    anchorEl = _useState6[0],
    setAnchorEl = _useState6[1];
  var _useState7 = (0, _react.useState)({}),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    popoverStyle = _useState8[0],
    setPopoverStyles = _useState8[1];
  var _useMemo = (0, _react.useMemo)(function () {
      var Caret = 'div',
        Options = 'div',
        className = 'border-none',
        style = {};
      if (!disabled) {
        className = 'cursor-pointer border-primary';
        style = {
          minWidth: '14rem'
        };
        Caret = function Caret() {
          return /*#__PURE__*/_react["default"].createElement(_ArrowDropDown["default"], {
            fontSize: "small"
          });
        };
        Options = function Options(_ref6) {
          var field = _ref6.field,
            form = _ref6.form;
          return /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
            open: Boolean(anchorEl),
            anchorEl: anchorEl,
            onClose: handleClose,
            elevation: 1,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'center'
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'center'
            }
          }, /*#__PURE__*/_react["default"].createElement("div", {
            style: popoverStyle,
            className: "bg-card py-2 shadow z-50 overflow-y-scroll"
          }, renderOptions({
            field: field,
            form: form,
            onClick: function onClick(value) {
              form.setFieldValue(name, value);
              setDisabled(true);
              handleClose();
            }
          })));
        };
      }
      return {
        Caret: Caret,
        Options: Options,
        className: className,
        style: style
      };
    }, [disabled, anchorEl]),
    Caret = _useMemo.Caret,
    Options = _useMemo.Options,
    className = _useMemo.className,
    style = _useMemo.style;
  function handleClick(e) {
    setAnchorEl(e.currentTarget);
    var _e$currentTarget$getB = e.currentTarget.getBoundingClientRect(),
      width = _e$currentTarget$getB.width;
    setPopoverStyles({
      width: width
    });
  }
  function handleClose() {
    setAnchorEl(null);
  }
  return /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name,
    render: function render(_ref7) {
      var field = _ref7.field,
        form = _ref7.form;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        onClick: handleClick,
        className: (0, _classnames["default"])('border-b-2 flex items-center justify-between', className),
        style: style
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "pr-10"
      }, disabled ? label : placeholder), /*#__PURE__*/_react["default"].createElement(Caret, null)), /*#__PURE__*/_react["default"].createElement(Options, {
        field: field,
        form: form
      }));
    }
  });
};
//# sourceMappingURL=ActionItem.js.map